export default from './simple-renderer';



// WEBPACK FOOTER //
// ./app/components/simple-renderer/index.js